import { SxProps, Theme } from '@mui/material';

export const venueConfigTableShellSx: SxProps<Theme> = {
  border: 1,
  borderColor: 'divider',
  borderRadius: 1,
  overflow: 'hidden',
  bgcolor: 'background.paper',
};

export const venueConfigTableHeaderRowSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  px: 2,
  py: 1.25,
  bgcolor: theme => (theme.palette.mode === 'light' ? 'grey.50' : 'action.hover'),
  borderBottom: 1,
  borderColor: 'divider',
};

export const venueConfigTableDataRowSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 2,
  px: 2,
  py: 1.5,
  borderBottom: 1,
  borderColor: 'divider',
  '&:last-child': { borderBottom: 0 },
};

export const venueConfigTableHeaderCellSx = {
  variant: 'subtitle2' as const,
  fontWeight: 600,
  color: 'text.secondary',
  fontSize: '0.8125rem',
  lineHeight: 1.4,
};

export const venueConfigDeleteIconProps = {
  fontSize: 'small' as const,
  color: 'error' as const,
};
